import { Banner as a } from "./index142.mjs";
import o, { useState as r, useEffect as i } from "react";
import c from "./index210.mjs";
import s from "./index211.mjs";
import { useCapacityCheck as m } from "./index115.mjs";
const C = () => {
  const [e, n] = r(!1), t = m();
  return i(() => {
    n(!t);
  }, [t]), e ? /* @__PURE__ */ o.createElement(
    a,
    {
      title: I18n.t("booking_engine.information.accommodate_guests_banner"),
      permanent: !0,
      Icon: c,
      variation: "warning",
      classes: s["capacity-banner"]
    }
  ) : null;
};
export {
  C as CapacityBanner
};
